import React, { useState, useEffect } from 'react';
import { ReactComponent as SortArrowIcon } from '../../assets/increase.svg';

import './styles.scss';

const Head = ({ headerGroups, onSort }) => {
  const [columnSort, setColumnSort] = useState(null);

  return (
    <div>
      {headerGroups.map(({ getHeaderGroupProps, headers }) => {
        const headerProps = getHeaderGroupProps();
        const hasWidth = headerProps && headerProps.width;

        return (
          <div
            {...headerProps}
            className={`row-main ${hasWidth ? 'row-main-width' : ''} headerRow`}
            key={headers[0].Header}
          >
            {headers.map(column => (
              <div className="table-head-cell" {...column.getHeaderProps()} key={column.id}>
                {column.render('Header')?.length > 0 ? (
                  <Header
                    column={column.render('Header')}
                    onSort={onSort}
                    headerProps={column.getHeaderProps()}
                    columnId={column.id}
                    columnSort={columnSort}
                    setColumnSort={setColumnSort}
                    sortable={column.sortable}
                  />
                ) : (
                  column.render('Header')
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

const Header = ({ column, onSort, columnSort, setColumnSort, columnId, sortable = true }) => {
  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    if (columnSort !== column) {
      setClickCount(0);
    }
  }, [columnSort, column]);

  const handleClick = () => {
    if (!sortable) return;

    setColumnSort(column);
    switch (clickCount) {
      case 0:
        setClickCount(1);
        onSort({ column: columnId, type: 'descending' });
        break;
      case 1:
        setClickCount(2);
        onSort({ column: columnId, type: 'ascending' });
        break;
      default:
        setClickCount(clickCount === 1 ? 2 : 1);
        onSort({ column: columnId, type: clickCount === 1 ? 'ascending' : 'descending' });
    }
  };

  return onSort === undefined ? (
    <div className="table-header-bold">{column}</div>
  ) : (
    <button className="table-header-text" style={{ cursor: !sortable && 'default' }} lonClick={handleClick}>
      <div className="table-header-bold">{column}</div>
      {sortable && (
        <SortArrowIcon
          className={`sort-arrow-icon ${clickCount === 1 ? 'hide-top-arrow' : ''} ${
            clickCount === 2 ? 'hide-bottom-arrow' : ''
          }`}
        />
      )}
    </button>
  );
};
export default Head;
